/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `FormControlType*`'s.
 */
export type FormControlType = FormControlTypeCheckbox | FormControlTypeRadio;

/**
 * The Checkbox form control type.
 */
export type FormControlTypeCheckbox = typeof FORM_CONTROL_TYPE_CHECKBOX;

/**
 * The Radio form control type.
 */
export type FormControlTypeRadio = typeof FORM_CONTROL_TYPE_RADIO;

/**
 * The Checkbox form control constant.
 */
export const FORM_CONTROL_TYPE_CHECKBOX = `checkbox`;

/**
 * The Radio form control constant.
 */
export const FORM_CONTROL_TYPE_RADIO = `radio`;
